"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _NotificationMetadataFilters = _interopRequireDefault(require("../constants/NotificationMetadataFilters.json"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/

/**
 * Component that accepts config_params for filters from ANS
 * and map them with `ansQueryFormat` to show dynamic  filter list
 * in view all notifications page.
 */
var NotificationConfigParser =
/*#__PURE__*/
function () {
  function NotificationConfigParser() {
    (0, _classCallCheck2.default)(this, NotificationConfigParser);
  }

  (0, _createClass2.default)(NotificationConfigParser, [{
    key: "addQueryFormat",

    /**
     * Adding the ansQuerFormat for filters
     * first parameter the array and the second parameter is key
     * i.e is used to set the field and value of ansQueryFormat
     * each object is iterated and 'ansQueryFormat' is inserted with given key.
     */
    value: function addQueryFormat(categories, key) {
      var _this = this;

      categories.map(
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        _regenerator.default.mark(function _callee(category) {
          var item;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  item = _this.getMapFieldValue(category, key);
                  /* adding key for each object */

                  category['key'] = item.value;
                  category.ansQueryFormat = {
                    "field": item.key,
                    "value": item.value,
                    "operator": "EQ"
                  };
                  /**
                   *check if the types exist in category recursively call the addQueryFormat
                   *to set ansQueryFormat for the 'types' also
                   */

                  if (!(category.types && category.types.length > 0)) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 6;
                  return _this.addQueryFormat(category.types, 'subtype');

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      return categories;
    }
    /**
     * Accepts the object and key.
     * returns the key value pair for any given key
     * this in turn used in setting the ansQueryFormat 'field' and 'values'
     */

  }, {
    key: "getMapFieldValue",
    value: function getMapFieldValue(item, key) {
      if (item.hasOwnProperty(key)) return {
        key: key,
        value: item[key]
      };
      throw new Error("Invalid map key");
    }
  }, {
    key: "getFilters",
    value: function getFilters(payload) {
      /* extract the categories from the config-param payload */
      var categories = [];
      var configParams = payload["notification-configuration"]["config-params"];

      if (!(0, _isEmpty2.default)(configParams) && configParams["config-param"].length > 0) {
        categories = configParams["config-param"][0].value;
        /* Parsing the stringified JSON */

        categories = categories.join(',');
        /* parser gives error as it cant differentiate to get the next object as catgories is an array after join*/

        categories = "[" + categories + "]";
        categories = JSON.parse(categories);
        /* pass the categories array and the key as params to set the ansQueryFormat in categories top level */

        categories = this.addQueryFormat(categories, "type");
      }
      /**
       * Final filter to be stored in notificaiton store
       * metadata is read from constant as this is not dynamin
       */


      return categories;
    }
  }]);
  return NotificationConfigParser;
}();

var _default = new NotificationConfigParser();

exports.default = _default;